/* Gift wrap and gift note in the bag. Always loaded, because the drawer is redrawn after adding to an empty bag and scripts inside it would not run. */
(function () {
  if (window.m4yCartGift) return; window.m4yCartGift = true;
  function drawer() { return document.querySelector('cart-drawer'); }
  function post(url, body) {
    var d = drawer();
    if (d && d.getSectionsToRender) { body.sections = d.getSectionsToRender().map(function (s) { return s.section || s.id; }); body.sections_url = window.location.pathname; }
    return fetch(url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  function paint(state) { var d = drawer(); if (d && d.renderContents && state && state.sections) { d.renderContents(state); } if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'm4y-cart-gift' }); }
  function add(id, quantity, props) { var it = { id: Number(id), quantity: quantity }; if (props) it.properties = props; return post(window.routes.cart_add_url, { items: [it] }); }
  function remove(key) { return post(window.routes.cart_change_url, { id: key, quantity: 0 }); }
  document.addEventListener('change', function (e) {
    var t = e.target, box = t.closest && t.closest('[data-m4y-cartgift]');
    if (!box) return;
    if (t.dataset.gift === 'wrap') {
      t.disabled = true;
      (t.checked ? add(t.dataset.variant, Number(box.dataset.items) || 1, null) : remove(t.dataset.key)).then(paint);
    } else if (t.dataset.gift === 'note') {
      var field = t.closest('.m4y-addon').querySelector('[data-gift-field]');
      field.hidden = !t.checked;
      if (t.checked) field.querySelector('textarea').focus();
      else if (t.dataset.key) remove(t.dataset.key).then(paint);
    } else if (t.matches('[data-gift-message]')) {
      var check = t.closest('.m4y-addon').querySelector('[data-gift=note]'), msg = t.value.trim();
      (check.dataset.key ? remove(check.dataset.key) : Promise.resolve()).then(function () {
        return msg ? add(check.dataset.variant, 1, { 'Gift message': msg }) : null;
      }).then(function (state) { return state || fetch(window.routes.cart_url + '.js').then(function () { return null; }); }).then(paint);
    }
  });
})();
